import { render } from "./BuyableElementV14.vue?vue&type=template&id=2a7b0fd4&scoped=true"
import script from "./BuyableElementV14.vue?vue&type=script&lang=ts"
export * from "./BuyableElementV14.vue?vue&type=script&lang=ts"

import "./BuyableElementV14.vue?vue&type=style&index=0&id=2a7b0fd4&lang=scss&scoped=true"
import "./BuyableElementV14.vue?vue&type=style&index=1&id=2a7b0fd4&lang=scss"
script.render = render
script.__scopeId = "data-v-2a7b0fd4"

export default script